import { authenticatedGet, authenticatedPatch } from './api-client';

export interface UserSettings {
    mirror_local_video: boolean;
    hide_participants_without_video: boolean;
}

export type UserSettingsPatch = Partial<UserSettings>;

export const DEFAULT_USER_SETTINGS: UserSettings = {
    mirror_local_video: true,
    hide_participants_without_video: false
};

interface UserSettingsResponse {
    result: string;
    data?: Partial<UserSettings>;
}

// Absent fields fall back to defaults so an older backend can't produce `undefined`.
function normalize(data: Partial<UserSettings> | undefined): UserSettings {
    return { ...DEFAULT_USER_SETTINGS, ...(data ?? {}) };
}

export async function fetchUserSettings(): Promise<UserSettings> {
    const response = await authenticatedGet<UserSettingsResponse>('/api/v1/user/settings');

    if (response.result !== 'success') {
        throw new Error('Failed to get user settings');
    }

    return normalize(response.data);
}

export async function updateUserSettings(patch: UserSettingsPatch): Promise<UserSettings> {
    const response = await authenticatedPatch<UserSettingsResponse>('/api/v1/user/settings', patch);

    if (response.result !== 'success') {
        throw new Error('Failed to update user settings');
    }

    return normalize(response.data);
}
